"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@mui/material/styles");
var _fonts = _interopRequireDefault(require("./fonts"));
var _colors = _interopRequireDefault(require("./colors"));
var ie11Vars = {};
if (window.document.documentMode) {
  ie11Vars = {
    ExpansionDetailsHeight: 200,
    DialogPaperScrollPaperHeight: '100%'
  };
}

/**
 * @param whitelabel
 * @returns {{typography: {useNextVariants: boolean, suppressDeprecationWarnings: boolean}, fontFamily: *, palette: {secondary: {light: *, contrastText: *, main: *}, error: {light: *, contrastText: *, main: *}, primary: {light: *, contrastText: (*), main: (*)}}, overrides: {MuiInputLabel: {shrink: {}, filled: {}}, MuiStepIcon: {text: {fontFamily: *, fill: *}}, MuiTable: {root: {fontFamily: *, minWidth: string}}, MuiListItemIcon: {root: {color: *}}, MuiChip: {root: {fontFamily: *, borderRadius: string}, label: {}, deleteIcon: {cursor: string}}, MuiButton: {root: {fontFamily: *, color: *}, label: {whiteSpace: string}}, MuiOutlinedInput: {root: {"&:hover:not($disabled):not($error) $notchedOutline": {borderColor: *}, borderWidth: string}}, MuiTableRow: {head: {fontFamily: *, color: (*), background: string, fontSize: *, borderTop: string}, root: {backgroundColor: *, "&:nth-of-type(odd)": {backgroundColor: *}}}, MuiFilledInput: {underline: {"&:hover:not($disabled):not($error):before": {borderColor: string}}}, MuiList: {padding: {paddingBottom: string, paddingTop: string}}, MuiTouchRipple: {root: {color: (*)}}, MuiTableHead: {}, MuiExpansionPanelSummary: {expanded: {minHeight: string, backgroundColor: (*), margin: string, color: (*), marginBottom: string, "&>:last-child": {margin: string, color: string, fontSize: *, fontWeight: string}}, expandIcon: {}, root: {minHeight: string}, content: {color: *, paddingRight: string, paddingLeft: string}}, MuiTypography: {body1: {fontFamily: *, color: *}, caption: {fontFamily: *}}, MuiTableCell: {head: {fontFamily: *, color: *, fontSize: *}, root: {padding: string, whiteSpace: string, borderBottom: string}, body: {fontFamily: *, color: *, fontSize: *}}, MuiExpansionPanel: {root: {boxShadow: string}}, MuiPaper: {rounded: {borderRadius: string}}, MuiFormLabel: {root: {fontFamily: *}, filled: {}}, MuiInputBase: {input: {fontFamily: *, color: *}, root: {fontFamily: *, color: *}}, MuiDialog: {paperWidthSm: {maxWidth: string}}, MuiIconButton: {root: {color: *, "&:hover": {backgroundColor: string}}}, MuiIcon: {root: {color: *}}, MuiSelect: {select: {"&:focus": {background: string}}, root: {minWidth: string}}, MuiInput: {underline: {"&:hover:not($disabled):not($error):before": {borderColor: string}}}, MuiSwitch: {root: {"&$checked": {color: string}}}}}}
 */
function themeWithWhitelabel() {
  var whitelabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  // Apply Material Ui Defaults and overrides here
  return (0, _styles.createTheme)({
    typography: {
      useNextVariants: true,
      suppressDeprecationWarnings: true,
      fontFamily: _fonts["default"].type.base
    },
    palette: {
      primary: {
        light: whitelabel ? whitelabel.lightColor : _colors["default"].lightBlue,
        main: whitelabel ? whitelabel.primaryColor : _colors["default"].skyBlue,
        contrastText: whitelabel ? whitelabel.buttonTextColor : _colors["default"].surface
      },
      secondary: {
        light: _colors["default"].lightGreen,
        main: _colors["default"].brandGreen,
        contrastText: _colors["default"].surface
      },
      white: {
        main: _colors["default"].white,
        contrastText: _colors["default"].mainTextGrey
      },
      "default": {
        main: _colors["default"].lightGrey,
        contrastText: _colors["default"].mainTextGrey
      },
      error: {
        light: _colors["default"].pink,
        main: _colors["default"].red,
        contrastText: _colors["default"].surface
      },
      custom: {
        textFieldHover: whitelabel ? whitelabel.primaryColor : _colors["default"].inputBlue,
        bubbleHover: whitelabel ? whitelabel.primaryColor : _colors["default"].bubbleHover
      },
      whitelabel: {
        buttonTextColor: whitelabel ? whitelabel.buttonTextColor : _colors["default"].surface,
        lightColor: whitelabel ? whitelabel.lightColor : "#D9F0F9"
      }
    },
    components: {
      styleOverrides: {
        // Name of the slot
        paper: {
          // Override styles here
          zIndex: 0
        }
      }
    }
  });
}
var _default = exports["default"] = themeWithWhitelabel;